import { STATUS_LABELS } from './constants';

export const today = (() => { const d = new Date(); d.setHours(0,0,0,0); return d; })();

export const fmtDate = s => {
  if (!s) return '—';
  const d = new Date(s);
  const m = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'][d.getMonth()];
  return `${d.getDate()} ${m}`;
};

export const isOverdue = t => {
  if (t.status !== 'in_progress' || !t.deadline) return false;
  return new Date(t.deadline) < today;
};

export const effectiveStatus = t => isOverdue(t) ? 'overdue' : t.status;

export const statusLabel = s => STATUS_LABELS[s] || s;

export const avInitials = name => (name ? name[0].toUpperCase() : '?');

export const rowToTask = r => ({
  id: r.id,
  title: r.title,
  desc: r.description || '',
  domain: r.domain,
  month: r.month,
  owner: r.owner,
  priority: r.priority,
  status: r.status,
  deadline: r.deadline || '',
  eta: r.eta || '',
  reason: r.reason || '',
  link: r.link || '',
  updatedBy: r.updated_by || '',
  updatedAt: r.updated_at ? new Date(r.updated_at).getTime() : Date.now(),
});

export const taskToRow = t => ({
  id: t.id,
  title: t.title,
  description: t.desc || '',
  domain: t.domain,
  month: t.month,
  owner: t.owner,
  priority: t.priority,
  status: t.status,
  deadline: t.deadline || null,
  eta: t.eta || null,
  reason: t.reason || '',
  link: t.link || '',
  updated_by: t.updatedBy || null,
});

export const diffTask = (a, b) => {
  if (!a) return '';
  const c = [];
  if (a.status !== b.status) c.push(`status → ${statusLabel(b.status)}`);
  if (a.priority !== b.priority) c.push(`priority → ${b.priority}`);
  if (a.owner !== b.owner) c.push(`owner → ${b.owner}`);
  if (a.deadline !== b.deadline) c.push(`deadline → ${fmtDate(b.deadline)}`);
  if (a.eta !== b.eta) c.push(`ETA → ${fmtDate(b.eta)}`);
  return c.join(', ');
};

export const timeAgo = t => {
  const s = Math.floor((Date.now() - t) / 1000);
  if (s < 60) return 'just now';
  if (s < 3600) return `${Math.floor(s/60)}m ago`;
  if (s < 86400) return `${Math.floor(s/3600)}h ago`;
  return `${Math.floor(s/86400)}d ago`;
};
